if (!customElements.get('number-counter')) {
  customElements.define(
    'number-counter',
    class NumberCounter extends HTMLElement {
      constructor() {
        super();

        this.number = parseInt(this.innerText.replace(',', '').replace('.', ''));

        if (!this.number) return;

        new IntersectionObserver(this.enterViewport.bind(this), { threshold: 1 }).observe(this);

        this.classList.add('initialized');
        this.innerText = '0';
      }

      enterViewport(entries, observer) {
        if (!entries[0].isIntersecting) return;

        observer.disconnect();

        var el = this;
        var number = this.number;
        var duration = 5000;
        var stepInterval;

        var n = Math.abs(Math.floor(duration / number));
        n = Math.max(n, 50);
        var endTime = new Date().getTime() + duration;
        function step() {
          var t, n;
          var currentTime = new Date().getTime();
          var d = Math.max((endTime - currentTime) / duration, 0),
            c = Math.ceil(number - (t = d) * t * t * number);
          (el.innerText =
            (((n = c.toString().split('.'))[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')), n.join('.'))),
            c == number && clearInterval(stepInterval);
        }

        requestAnimationFrame(() => {
          stepInterval = setInterval(step, n);
          step();

          this.classList.add('visible');
        });
      }
    }
  );
}
